export default "__VITE_ASSET__D$U9f0yS__"